import * as React from 'react';
import classnames from 'classnames';
import { Util, Link } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';
import { SubMenu } from '../../SubMenu/SubMenu.js';

const SiteNavItem = ({ label , link , childMenuItems =[] , parameters , focusCallback , activeSubMenu , setActiveSubMenu  })=>{
    const hasSubmenu = (childMenuItems === null || childMenuItems === void 0 ? void 0 : childMenuItems.length) > 0;
    const shouldHandleSubmenu = !Util.isTouchDevice() && hasSubmenu;
    const linkRef = React.useRef();
    const isActive = React.useMemo(()=>activeSubMenu === label
    , [
        activeSubMenu,
        label
    ]);
    const [mouseOver, setMouseOver] = React.useState(false);
    /**
   * On cursor events, delay the open and closing of the submenus with 0.4s and 0.2s to prevent users
   * from opening the submenu accidentally when moving their cursor over the site nav
   */ React.useEffect(()=>{
        if (isActive === mouseOver) {
            return;
        }
        const ms = mouseOver ? 400 : 200;
        const timeout = setTimeout(()=>setActiveSubMenu(mouseOver ? label : '')
        , ms);
        return ()=>clearTimeout(timeout)
        ;
    }, [
        mouseOver
    ]);
    const closeSubMenu = React.useMemo(()=>{
        return ()=>{
            var ref;
            setActiveSubMenu('');
            (ref = linkRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        };
    }, [
        setActiveSubMenu,
        linkRef
    ]);
    const handleMouseOver = ()=>setMouseOver(true)
    ;
    const handleMouseLeave = ()=>setMouseOver(false)
    ;
    const handleKeyDown = React.useCallback((event)=>{
        if (event.key === 'Escape') {
            closeSubMenu();
        }
        // Handle Enter and Space keys
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.stopPropagation();
            setActiveSubMenu(activeSubMenu === label ? '' : label);
        }
    }, [
        closeSubMenu,
        setActiveSubMenu,
        label
    ]);
    return /*#__PURE__*/ React.createElement("li", {
        className: classnames('site-nav-item', {
            [`site-nav-item--${parameters === null || parameters === void 0 ? void 0 : parameters.menuKey}`]: !!(parameters === null || parameters === void 0 ? void 0 : parameters.menuKey),
            _is_active: link === null || link === void 0 ? void 0 : link.active
        }),
        "data-t": "site-nav-item",
        // We are disabling the a11y linter rule which requires onMouseOver to be used with onFocus.
        // The onFocus is implemented on the Link element, therefore the rule is met but the linter cant tell.
        // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
        onMouseOver: shouldHandleSubmenu ? handleMouseOver : undefined,
        onMouseLeave: shouldHandleSubmenu ? handleMouseLeave : undefined
    }, /*#__PURE__*/ React.createElement(Link, {
        className: "site-nav-item__link",
        "data-t": "site-nav-item-link",
        url: link === null || link === void 0 ? void 0 : link.href,
        openInNewWindow: link === null || link === void 0 ? void 0 : link.openInNewWindow,
        // Handle keyboard usage
        onKeyDown: shouldHandleSubmenu ? handleKeyDown : undefined,
        onFocus: focusCallback,
        ref: linkRef,
        ariaHasPopup: hasSubmenu,
        ariaIsExpanded: isActive
    }, label, hasSubmenu && /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-down",
        height: 18,
        width: 18
    })), hasSubmenu && /*#__PURE__*/ React.createElement(SubMenu, {
        menuItems: childMenuItems,
        isActive: isActive,
        closeSubMenu: closeSubMenu
    }));
};

export { SiteNavItem as default };
//# sourceMappingURL=SiteNavItem.js.map
